import { gql } from 'apollo-angular';
import { MinimumWageScopeConfig } from '../manage-minimum-wage-form/enum/minimum-wage-scope.enum';

export const editMinimumWageMutation = {
  [MinimumWageScopeConfig.ALL_PROJECTS_IN_JURISDICTION]: gql`
    mutation updateMinimumWages(
      $id: UUID!
      $tenantId: UUID!
      $input: MinimumWageAllProjectsInJurisdictionInputModelInput!
    ) {
      updateMinimumWageForAllProjectsInJurisdiction(
        id: $id
        tenantId: $tenantId
        input: $input
      ) {
        data {
          createdBy
          createdDate
          effectiveDate
          id
          jurisdictionId
          modifiedBy
          modifiedDate
          rate
          scopeId
          tenantId
        }
        errors {
          message
        }
      }
    }
  `,

  [MinimumWageScopeConfig.ALL_LOCATIONS_IN_PROJECT]: gql`
    mutation createMinimumWages(
      $id: UUID!
      $tenantId: UUID!
      $input: MinimumWageAllLocationsInProjectInputModelInput!
    ) {
      updateMinimumWageForAllLocationsInProject(
        id: $id
        tenantId: $tenantId
        input: $input
      ) {
        data {
          createdBy
          createdDate
          effectiveDate
          id
          jurisdictionId
          modifiedBy
          modifiedDate
          rate
          scopeId
          tenantId
        }
        errors {
          message
        }
      }
    }
  `,
  [MinimumWageScopeConfig.SPECIFIC_LOCATION_IN_PROJECT]: gql`
    mutation createMinimumWages(
      $id: UUID!
      $tenantId: UUID!
      $input: MinimumWageSpecificLocationInProjectInputModelInput!
    ) {
      updateMinimumWageForSpecificLocationInProject(
        id: $id
        tenantId: $tenantId
        input: $input
      ) {
        data {
          createdBy
          createdDate
          effectiveDate
          id
          jurisdictionId
          modifiedBy
          modifiedDate
          rate
          scopeId
          tenantId
        }
        errors {
          message
        }
      }
    }
  `,
};
